// Спільні елементи показу сповіщень (дзвіночок і сторінка /notifications).
import { NOTIFICATION_TYPE_LABELS, NOTIFICATION_TYPE_TONES, type NotificationType } from '@unisched/shared';
import { cn } from '@/lib/cn';
import { formatDateTime, plural } from '@/lib/format';
import { Badge } from '@/ui';

/** «щойно», «5 хв тому», «3 год тому», далі — ДД.ММ.РРРР ГГ:ХХ. */
export function timeAgo(iso: string, now = Date.now()): string {
  const diff = Math.max(0, now - new Date(iso).getTime());
  const min = Math.floor(diff / 60_000);
  if (min < 1) return 'щойно';
  if (min < 60) return `${min} хв тому`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} год тому`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d} ${plural(d, ['день', 'дні', 'днів'])} тому`;
  return formatDateTime(iso);
}

export function NotificationTypeBadge({ type, size = 'sm' }: { type: NotificationType; size?: 'sm' | 'md' }) {
  return (
    <Badge tone={NOTIFICATION_TYPE_TONES[type]} size={size} dot>
      {NOTIFICATION_TYPE_LABELS[type]}
    </Badge>
  );
}

/** Позначка непрочитаного. */
export function UnreadDot({ unread, className }: { unread: boolean; className?: string }) {
  return (
    <span
      className={cn('mt-1.5 size-2 shrink-0 rounded-full', unread ? 'bg-primary' : 'bg-transparent', className)}
      aria-label={unread ? 'Непрочитане' : undefined}
      role={unread ? 'img' : undefined}
    />
  );
}

/** Внутрішнє посилання сповіщення (лише шляхи застосунку, без зовнішніх адрес). */
export function safeLink(link: string | null | undefined): string | null {
  if (!link || !link.startsWith('/') || link.startsWith('//')) return null;
  return link;
}
